import FolderIcon from '@material-ui/icons/Folder';
export const FileIcon = FolderIcon;

